import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBSpinner,
  MDBBtn,
  MDBCol,
  MDBDatatable,
  MDBIcon,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
  MDBAlert,
} from "mdb-react-ui-kit";
import { Tooltip } from "react-tooltip";
import MainLinks from "../../navlinks/MainLinks";
import {
  getSpecificBillingGroups,
  updateBillingGroups,
  getSpecificBIllingUser,
  getSpecificBIllingGroupGroups,
  getMisc,
} from "../../../apiclients/streamsapi_bridge";
import Body from "../../body/BodyPage";
import BillingPreferences from "./BillingPreferences";
import LocationAddress from "./LocationAddress";
import BillingAddress from "./BillingAddress";
import ShippingAddress from "./ShippingAddress";
import AssignSeats from "./AssignSeats";
import AvailableSeats from "./AvailableSeats";
import TelephoneNumbers from "../../TelephoneNumbers";
import HardwareProducts from "./HardwareProducts";
// import HardwareRental from "./HardwareRental";
// import NRCFinance from "./NRCFinance";
import BillingInvoice from "./BillingInvoice";
import BillingGroupAdmin from "./BillingGroupAdmin";
import SaveChanges from "../../../components/topviews/saveCancel";
import { useAdminContext } from "../../../components/adminstore/Admin-Context";
// import DeleteUsers from "./DeleteUsers";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import BillingAvailablePHNumbers from "./BillingAvailablePHNumbers";
import BillingUsers from "./BillingUsers";
import BillingGroups from "./BillingGroups";
import UIConstant from "../../../apiclients/UIConstant";
import BillingGeneral from "./BillingGeneral";
import EditWarning from "../../header/EditWarning";

// import { json } from "body-parser";

function BillingGroupDetails() {
  const location = useLocation();
  const tab =
    location.state && location.state.tab ? location.state.tab + "" : "tab1";
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const [basicActive, setBasicActive] = useState(tab);
  const [defaults, setdefaults] = useState({});
  const [isloading, setIsloading] = useState(false);
  // const [values, setValue] = useState()
  const { isEdited, setEdited } = useAdminContext();
  const [successMessage, setSuccessMessage] = useState("");
  const [rerender, setRerender] = useState(false);
  const [assignseats, setAssignseats] = useState([]);
  const [availableSeats, setAvailableSeats] = useState([]);
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);

  const [deletuser, setdeletuser] = useState([]);
  const [isSameAsLocation, setIsSameAsLocation] = useState(false);
  const [isSameAsBilling, setIsSameAsBilling] = useState(false);
  const isWholesaleAcc =
    JSON.parse(sessionStorage.getItem("admin_session"))?.isWholesaleAcc ??
    false;

  // const [showPopup, setShowPopup] = useState(false);
  const [userToRemove, setUserToRemove] = useState(false);
  // const[userName, setUserName]= useState([])
  const [isLoading, setisLoading] = useState(false);

  console.log("usersdata" + userToRemove);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const removeUserRef = useRef(null);
  console.log("usersdata" + userToRemove);

  const dtogglePopup = () => setUserToRemove((prev) => !prev);

  function handleClick() {
    removeUserRef.current.click();
    console.log("handleClick triggered");
  }
  const isAdminSession = JSON.parse(sessionStorage.getItem("admin_session"));
  const allowSeats = isAdminSession?.permissions
    ? isAdminSession?.permissions.includes(UIConstant.ALLOW_MANAGED_SEAT)
    : true;

  //  function deleteUsers(evntData, agentid) {
  //     evntData.preventDefault();
  //     evntData.stopPropagation();
  //     let seluser =  users.billing_users.map((udata) => udata.agentid !== agentid);
  //     console.log("selected user data" + JSON.stringify(seluser))

  //     setUserToRemove(true)
  //     setUsers(seluser)

  //  }

  console.log(userToRemove);

  console.log(deletuser);

  const handleOk = () => {
    setEdited(false);
    reset();
    if (targetView.indexOf("/") !== -1) {
      navigate(targetView);
    } else {
      setBasicActive(targetView);
    }
    setShowWarning(false);
  };

  const navigate = useNavigate();
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    } else if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }
    setBasicActive(value);
  };
  const {
    register,
    reset,
    watch,
    formState: { isDirty, dirtyFields, errors },
    handleSubmit,
    setError,
    setValue,
    getValues,
    control,
    clearErrors,
  } = useForm({
    defaultValues: {
      bgrp_name: "",
      billing_preference: {
        street_addr: "",
        city: "",
        state: "",
        country: "",
        zip: "",
        billing_type: 1,
        currency: "USD($)",
        eft_info: {
          bank_name: "",
          name_on_account: "",
          bank_account_number: "",
          bank_routing_number: "",
        },
        card_info: {
          exp_date: "",
          card_type: "",
          card_number: "",
          name_on_card: "",
        },
      },
      address: {
        loc_addr: {
          zip: "",
          city: "",
          state: "",
          country: "",
          specific_location: "",
          street_addr1: "",
          street_addr2: "",
        },
        bill_addr: {
          zip: "",
          city: "",
          state: "",
          country: "",
          specific_location: "",
          street_addr1: "",
          street_addr2: "",
          same_as_loc_address: false,
        },
        ship_addr: {
          zip: "",
          city: "",
          state: "",
          country: "",
          specific_location: "",
          street_addr1: "",
          street_addr2: "",
          same_as_loc_address: false,
        },
      },
      bgrp_id: "",
      // bgrp_name: "",
      assign_seats: [
        { service_id: "", no_of_seats: "" },
        { service_id: "", no_of_seats: "" },
      ],
      available_seats: [
        { bgrp_id: "", service_id: "", no_of_seats: "" },
        { bgrp_id: "", service_id: "", no_of_seats: "" },
      ],
      billing_admin_details: {
        to_email: "",
        cc_email: "",
        bcc_email: "",
        admin_name: "",
      },
      hw_products: [],
      emi_charge_groups: [],
      assign_seats: [],
      available_seats: [],
      default_invoice: "",
    },
  });

  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const section4 = useRef(null);
  const section5 = useRef(null);
  const section6 = useRef(null);
  const section7 = useRef(null);
  const section8 = useRef(null);
  const section9 = useRef(null);
  const section10 = useRef(null);
  const section11 = useRef(null);
  const containerRef = useRef(null);

  const [billingType, setBillingType] = useState("Credit Card");

  // const [successMessage, setSuccessMessage] = useState("");

  const [hwProductList, sethwProductList] = useState([]);
  const [hwRentalList, sethwRentalList] = useState([]);
  const [emiProductList, setemiProductList] = useState([]);
  const [hwEditable, sethwEditable] = useState(0);
  const [invoice, setInvoice] = useState([]);
  const [country, setcountry] = useState([]);
  const [states, setstates] = useState([]);
  // const [sourceNumber, setSourceNumber] = useState([]);
  const [billingTypesList, setbillingTypesList] = useState({});
  const [bgroupName, setbgroupName] = useState("");

  const [billingGInfo, setbillingGInfo] = useState(
    location.state ? location.state : {}
  );

  console.log("billing info data" + JSON.stringify(billingGInfo));
  const handleBillingTypeChange = (event) => {
    setBillingType(event.target.value);
  };

  let billingGroupType = billingGInfo.billing_group_type;
  console.log(billingGroupType);
  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  async function getSpecificBG() {
    try {
      await fetchBillingInfoMisc();
      setIsloading(true);
      const response = await getSpecificBillingGroups(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        billingGInfo.billing_group_id
      );
      setIsloading(false);
      const rawData = await response.json();
      console.log(
        "Specific billing group data :::::::::::::::" + JSON.stringify(rawData)
      );
      setbgroupName(rawData?.billing_group_details?.billing_group_name ?? "");
      reset({
        bgrp_name: rawData?.billing_group_details?.billing_group_name ?? "",
        billing_preference: {
          billing_type:
            rawData?.billing_group_details?.billing_preferences?.billing_type ??
            1,
          street_addr:
            rawData?.billing_group_details?.billing_preferences
              ?.street_address ?? "",
          city: rawData?.billing_group_details?.billing_preferences?.city ?? "",
          state:
            rawData?.billing_group_details?.billing_preferences?.state ?? "",
          country:
            rawData?.billing_group_details?.billing_preferences?.country ?? "",
          zip: rawData?.billing_group_details?.billing_preferences?.zip ?? "",
          currency: "USD($)",
          card_info: {
            card_type:
              rawData?.billing_group_details?.billing_preferences
                ?.credit_card_type ?? "",
            name_on_card:
              rawData?.billing_group_details?.billing_preferences
                ?.name_on_card ?? "",
            card_number:
              rawData?.billing_group_details?.billing_preferences
                ?.credit_card_number ?? "",
            exp_date:
              rawData?.billing_group_details?.billing_preferences?.exp_date ??
              "",
          },

          eft_info: {
            name_on_account:
              rawData?.billing_group_details?.billing_preferences
                ?.name_on_account ?? "",
            bank_name:
              rawData?.billing_group_details?.billing_preferences?.bank_name ??
              "",
            bank_routing_number:
              rawData?.billing_group_details?.billing_preferences
                ?.bank_routing_number ?? "",
            bank_account_number:
              rawData?.billing_group_details?.billing_preferences
                ?.bank_account_number ?? "",
          },
        },
        address: {
          loc_addr: {
            zip: rawData?.billing_group_details?.location_address?.zip ?? "",
            city: rawData?.billing_group_details?.location_address?.city ?? "",
            state:
              rawData?.billing_group_details?.location_address?.state ?? "",
            country:
              rawData?.billing_group_details?.location_address?.country ?? "",
            specific_location:
              rawData?.billing_group_details?.location_address
                ?.specific_location ?? "",
            street_addr1:
              rawData?.billing_group_details?.location_address
                ?.street_address1 ?? "",
            street_addr2:
              rawData?.billing_group_details?.location_address
                ?.street_address2 ?? "",
          },
          bill_addr: {
            zip: rawData?.billing_group_details?.billing_address?.zip ?? "",
            city: rawData?.billing_group_details?.billing_address?.city ?? "",
            state: rawData?.billing_group_details?.billing_address?.state ?? "",
            country:
              rawData?.billing_group_details?.billing_address?.country ?? "",
            specific_location:
              rawData?.billing_group_details?.billing_address
                ?.specific_location ?? "",
            street_addr1:
              rawData?.billing_group_details?.billing_address
                ?.street_address1 ?? "",
            street_addr2:
              rawData?.billing_group_details?.billing_address
                ?.street_address2 ?? "",
            same_as_loc_address: false,
          },
          ship_addr: {
            zip: rawData?.billing_group_details?.shipping_address?.zip ?? "",
            city: rawData?.billing_group_details?.shipping_address?.city ?? "",
            state:
              rawData?.billing_group_details?.shipping_address?.state ?? "",
            country:
              rawData?.billing_group_details?.shipping_address?.country ?? "",
            specific_location:
              rawData?.billing_group_details?.shipping_address
                ?.specific_location ?? "",
            street_addr1:
              rawData?.billing_group_details?.shipping_address
                ?.street_address1 ?? "",
            street_addr2:
              rawData?.billing_group_details?.shipping_address
                ?.street_address2 ?? "",
            same_as_loc_address: false,
          },
        },
        // bgrp_name: "",
        assign_seats: [],

        available_seats: [],

        hw_products: [],
        emi_charge_groups: [],
        billing_admin_details: {
          to_email:
            rawData?.billing_group_details?.billing_admin_details?.email_to ??
            "",
          cc_email:
            rawData?.billing_group_details?.billing_admin_details?.email_cc ??
            "",
          bcc_email:
            rawData?.billing_group_details?.billing_admin_details?.email_bcc ??
            "",
          admin_name:
            rawData?.billing_group_details?.billing_admin_details?.admin_name ??
            "",
        },
        default_invoice: rawData?.billing_group_details?.default_invoice ?? "",
      });

      setAssignseats(rawData?.billing_group_details?.assign_seats || []);
      setAssignseats(rawData?.billing_group_details?.assign_seats || []);

      setAvailableSeats(rawData?.billing_group_details?.purchased_seats || []);
      sethwProductList(rawData?.billing_group_details?.hw_prod_list || []);
      sethwRentalList(
        rawData?.billing_group_details?.hw_rental_prod_list || []
      );
      setemiProductList(rawData?.billing_group_details?.emi_prod_list || []);
      sethwEditable(rawData?.billing_group_details?.isHardWareEditable || 0);
      if (billingGInfo?.billing_group_id) {
        setTimeout(() => {
          const section = document.getElementById("section-2");
          if (section) {
            section.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 100);
      }
    } catch (e) {
      console.log(`Unable to load the sepcific group info:${e}`);
    }
  }

  console.log(assignseats);
  console.log(availableSeats);
  console.log(assignseats);
  console.log(availableSeats);

  // console.log(users)
  async function fetchBillingInfoMisc() {
    try {
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      const params = {
        misc: ["billing_settings_info"],
        billing_group_id: billingGInfo.billing_group_id,
      };
      setIsloading(true);
      const serverResponse = await getMisc(siteid, params);
      setIsloading(false);
      if (!serverResponse.ok) {
        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        const responseData = await serverResponse.json();
        console.log("Response Data:", JSON.stringify(responseData));
        setInvoice(
          (
            responseData?.misc?.billing_settings_info?.invoice_groups || []
          )?.filter(
            (group) =>
              parseInt(group.billing_group_id) !==
              parseInt(billingGInfo.billing_group_id)
          ) ?? []
        );
        setcountry(
          responseData?.misc?.billing_settings_info?.country_list || []
        );
        setstates(responseData?.misc?.billing_settings_info?.state_list || []);
        // setSourceNumber(
        //   responseData?.misc?.billing_settings_info?.available_phonenumbers ||
        //     []
        // );
        setbillingTypesList(
          responseData?.misc?.billing_settings_info?.billing_types || {}
        );
      }
    } catch (error) {
      console.error("[fetchAddLocationMisk] Error:", error);
    }
  }

  useEffect(() => {
    if (billingGInfo.billing_group_id || rerender) {
      getSpecificBG();

      setRerender(false);
    }
  }, [billingGInfo.billing_group_id, rerender]);

  function closeSave(e) {
    reset();
  }

  const isSave = Object.keys(dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    setEdited(isSave);
    if (!isSave) {
      setIsSameAsLocation(false);
      setIsSameAsBilling(false);
    }
  }, [isSave]);

  const onSubmit = async (data) => {
    console.log(Object.keys(dirtyFields));
    const modifiedData = prepareFinalJson(dirtyFields, data);
    if (modifiedData) {
      modifiedData.reqid = 130;
      modifiedData.siteid = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).siteid;
      modifiedData.bgrp_id = billingGInfo.billing_group_id;
      console.log(
        "modified data for billing edit :::" + JSON.stringify(modifiedData)
      );
      console.log(JSON.stringify(modifiedData));
      setIsloading(true);
      let saverep = await updateBillingGroups(modifiedData);
      console.log(saverep);
      console.log(`reponse of billing edit :::: ${JSON.stringify(saverep)}`);
      let saverepMsg = await saverep.json();
      console.log("response of modified data :::" + JSON.stringify(saverepMsg));
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      if (saverepMsg.status && saverepMsg.status == "success") {
        setRerender(true);
        setSuccessMessage(saverepMsg.message);
      } else {
        if (saverepMsg.message?.errors) {
          saverepMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              console.log(fieldElement.offsetTop);
            }
            console.log(fieldElement);
            if (fieldElement) {
              fieldElement.focus();
              fieldElement.scrollIntoView({ behavior: "smooth" });
            }
          });
        }
      }
    }
  };

  function prepareFinalJson(dirtyFields, data) {
    const modifiedData = {};
    console.log("dirtyFields :::::::::::::: " + JSON.stringify(dirtyFields));
    console.log("data :::::::::::::: " + JSON.stringify(data));

    function recurse(dirtyFields, data, modifiedData) {
      for (const field of Object.keys(dirtyFields)) {
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            modifiedData[field] = {};
            recurse(dirtyFields[field], data[field], modifiedData[field]);
          } else if (
            Array.isArray(data[field]) &&
            Array.isArray(dirtyFields[field]) &&
            field === "available_seats"
          ) {
            modifiedData[field] = data[field]
              .map((item, index) => {
                if (
                  dirtyFields[field][index]?.bgrp_id ||
                  dirtyFields[field][index]?.no_of_seats
                ) {
                  return {
                    service_id: item.serviceid,
                    ...(dirtyFields[field][index]?.bgrp_id && {
                      bgrp_id: parseInt(item.bgrp_id),
                    }),
                    ...(dirtyFields[field][index]?.no_of_seats && {
                      no_of_seats: parseInt(item.no_of_seats),
                    }),
                  };
                }
                return null;
              })
              .filter((item) => item !== null);
          } else if (
            Array.isArray(data[field]) &&
            Array.isArray(dirtyFields[field]) &&
            field === "hw_products"
          ) {
            modifiedData[field] = data[field]
              .map((item, index) => {
                if (
                  dirtyFields[field][index]?.bgrp_id ||
                  dirtyFields[field][index]?.quantity
                ) {
                  return {
                    id: item.id,
                    ...(dirtyFields[field][index]?.bgrp_id && {
                      bgrp_id: parseInt(item.bgrp_id),
                    }),
                    ...(dirtyFields[field][index]?.quantity && {
                      quantity: parseInt(item.quantity),
                    }),
                  };
                }
                return null;
              })
              .filter((item) => item !== null);
          } else if (
            Array.isArray(data[field]) &&
            Array.isArray(dirtyFields[field]) &&
            field === "emi_charge_groups"
          ) {
            modifiedData[field] = data[field]
              .map((item, index) => {
                if (
                  dirtyFields[field][index]?.bgrp_id ||
                  dirtyFields[field][index]?.price
                ) {
                  return {
                    id: item.id,
                    ...(dirtyFields[field][index]?.bgrp_id && {
                      bgrp_id: parseInt(item.bgrp_id),
                    }),
                    ...(dirtyFields[field][index]?.price && {
                      price: parseInt(item.price),
                    }),
                  };
                }
                return null;
              })
              .filter((item) => item !== null);
          } else {
            modifiedData[field] = data[field];
          }
        }
      }
    }

    recurse(dirtyFields, data, modifiedData);
    return modifiedData;
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollspyLinks = document.querySelectorAll(".nav-link");
      const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
      const stickyParent = lastLink.closest(".sticky-top");
      if (stickyParent && lastLink.classList.contains("active")) {
        lastLink.classList.remove("active");
        for (let i = 0; i < scrollspyLinks.length; i++) {
          const firstLink = scrollspyLinks[i];
          const parent = firstLink.closest(".sticky-top");
          if (parent) {
            firstLink.classList.add("active");
            break;
          }
        }
      }
    }, 200);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      setTimeout(() => {
        container.scrollTo({
          top: 5,
          behavior: "smooth",
        });

        setTimeout(() => {
          container.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, 100);
      }, 500);
    }
  }, [basicActive]);

  return (
    <React.Fragment>
      <>
        <MainLinks active={5} />
        <Body
          tablinks={5}
          sublink={297}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/billinglanding");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/billinglanding");
                            }}
                          >
                            <strong>{t("billingGroup")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/billinglanding");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/billinglanding");
                            }}
                          >
                            <strong>{t("billingGroup")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href="#">
                            <strong>{bgroupName}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                    </h5>
                  </div>
                  <div className="card-body px-0">
                    <div className="pb-2">
                      <h5 className="fw-600 mt-2 ">{bgroupName}</h5>
                      <p className="mt-2 text-secondary">
                        Group Type: {billingGInfo.billing_group_type}
                      </p>
                    </div>

                    <MDBTabs className="mb-3">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab1")}
                          active={basicActive === "tab1"}
                        >
                          Settings
                        </MDBTabsLink>
                      </MDBTabsItem>
                      {!isWholesaleAcc && (
                        <>
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => handleBasicClick("tab2")}
                              active={basicActive === "tab2"}
                            >
                              Users
                            </MDBTabsLink>
                          </MDBTabsItem>
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => handleBasicClick("tab3")}
                              active={basicActive === "tab3"}
                            >
                              Billing Groups
                            </MDBTabsLink>
                          </MDBTabsItem>
                          {/* <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab4")}
                          active={basicActive === "tab4"}
                        >
                          Super Admins
                        </MDBTabsLink>
                      </MDBTabsItem> */}
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => handleBasicClick("tab5")}
                              active={basicActive === "tab5"}
                            >
                              {billingGInfo.billing_group_type}s{" "}
                              <MDBIcon
                                fas
                                icon="info-circle"
                                className="ms-2 InvoiceTooltip"
                              />
                            </MDBTabsLink>
                          </MDBTabsItem>
                        </>
                      )}
                    </MDBTabs>

                    <MDBTabsContent>
                      <MDBTabsPane open={basicActive === "tab1"}>
                        <MDBRow>
                          <MDBCol
                            size="2"
                            md="2"
                            lg="2"
                            sm="12"
                            className="col-sm-100 pr-0 leftTabs"
                          >
                            <MDBScrollspy container={containerRef}>
                              <MDBScrollspyLink targetRef={section1}>
                                General
                              </MDBScrollspyLink>
                              {!isWholesaleAcc && (
                                <>
                                  {billingGInfo.billing_group_type ===
                                    "Invoice" && (
                                    <MDBScrollspyLink targetRef={section2}>
                                      Billing Preferences
                                    </MDBScrollspyLink>
                                  )}
                                  <MDBScrollspyLink targetRef={section3}>
                                    Location Address
                                  </MDBScrollspyLink>
                                  <MDBScrollspyLink targetRef={section4}>
                                    Billing Address
                                  </MDBScrollspyLink>
                                  <MDBScrollspyLink targetRef={section5}>
                                    Shipping Address
                                  </MDBScrollspyLink>
                                </>
                              )}
                              {billingGInfo.billing_group_type === "Invoice" &&
                                allowSeats && (
                                  <>
                                    {!isWholesaleAcc && (
                                      <MDBScrollspyLink targetRef={section6}>
                                        Assign Seats
                                      </MDBScrollspyLink>
                                    )}
                                    <MDBScrollspyLink targetRef={section7}>
                                      Available Seats{" "}
                                      <MDBIcon
                                        fas
                                        icon="info-circle"
                                        className="ms-2 AvailableSeats"
                                      />
                                    </MDBScrollspyLink>
                                  </>
                                )}
                              {!isWholesaleAcc && (
                                <>
                                  <MDBScrollspyLink targetRef={section8}>
                                    Billing Group Admin Details
                                  </MDBScrollspyLink>
                                  {billingGInfo.billing_group_type ===
                                    "Invoice" && (
                                    <>
                                      <MDBScrollspyLink targetRef={section9}>
                                        Available Phone Numbers
                                        <MDBIcon
                                          fas
                                          icon="info-circle"
                                          className="ms-1 AvailablePhoneNumbers"
                                        />
                                      </MDBScrollspyLink>
                                    </>
                                  )}
                                  <MDBScrollspyLink targetRef={section10}>
                                    Hardware, Hardware Rental & Finance{" "}
                                    <MDBIcon
                                      fas
                                      icon="info-circle"
                                      className="ms-1 HardwareProducts"
                                    />
                                  </MDBScrollspyLink>
                                  {billingGInfo.billing_group_type ===
                                    "Sub total" && (
                                    <>
                                      <MDBScrollspyLink targetRef={section11}>
                                        Default Invoice
                                      </MDBScrollspyLink>
                                    </>
                                  )}
                                </>
                              )}
                            </MDBScrollspy>
                          </MDBCol>

                          <MDBCol
                            size="12"
                            md="12"
                            sm="12"
                            pr-0
                            className="col-sm-100 pr-0 leftTabContent"
                          >
                            <div className="vtabHeightHunt pr-5">
                              <div
                                id="element"
                                ref={containerRef}
                                className="scrollspy-example2"
                              >
                                <section ref={section1} id="section-1">
                                  <BillingGeneral
                                    register={register}
                                    errors={errors}
                                    groupType={billingGInfo.billing_group_type}
                                  />
                                </section>
                                {!isWholesaleAcc && (
                                  <>
                                    {billingGInfo.billing_group_type ===
                                      "Invoice" && (
                                      <>
                                        <div class="routing-border mt-2"></div>
                                        <section ref={section2} id="section-2">
                                          <BillingPreferences
                                            register={register}
                                            setValue={setValue}
                                            errors={errors}
                                            setError={setError}
                                            watch={watch}
                                            clearErrors={clearErrors}
                                            billingTypesList={billingTypesList}
                                            countryList={country}
                                            states={states}
                                            billinggrpid={
                                              billingGInfo.billing_group_id
                                            }
                                            control={control}
                                          />
                                        </section>
                                      </>
                                    )}

                                    <div class="routing-border mt-2"></div>

                                    <section ref={section3} id="section-3">
                                      <LocationAddress
                                        register={register}
                                        watch={watch}
                                        errors={errors}
                                        setValue={setValue}
                                        countryList={country}
                                        states={states}
                                        clearErrors={clearErrors}
                                      />
                                    </section>

                                    <div class="routing-border mt-2"></div>
                                    <section ref={section4} id="section-4">
                                      <BillingAddress
                                        register={register}
                                        watch={watch}
                                        errors={errors}
                                        setValue={setValue}
                                        countryList={country}
                                        states={states}
                                        clearErrors={clearErrors}
                                        setIsSameAsBilling={setIsSameAsBilling}
                                        isSameAsBilling={isSameAsBilling}
                                      />
                                    </section>

                                    <div class="routing-border mt-2"></div>
                                    <section ref={section5} id="section-5">
                                      <ShippingAddress
                                        register={register}
                                        watch={watch}
                                        errors={errors}
                                        setValue={setValue}
                                        countryList={country}
                                        states={states}
                                        clearErrors={clearErrors}
                                        setIsSameAsLocation={
                                          setIsSameAsLocation
                                        }
                                        isSameAsLocation={isSameAsLocation}
                                      />
                                    </section>
                                  </>
                                )}
                                {billingGInfo.billing_group_type ===
                                  "Invoice" &&
                                  allowSeats && (
                                    <>
                                      {!isWholesaleAcc && (
                                        <>
                                          <div class="routing-border mt-2"></div>
                                          <section
                                            ref={section6}
                                            id="section-6"
                                          >
                                            <AssignSeats
                                              register={register}
                                              watch={watch}
                                              errors={errors}
                                              setValue={setValue}
                                              getValues={getValues}
                                              assignseats={assignseats}
                                              // setAssignseats={setAssignseats}
                                            />
                                          </section>
                                        </>
                                      )}
                                      <div class="routing-border mt-2"></div>
                                      <section ref={section7} id="section-7">
                                        <div
                                          className="mainText mt-3"
                                          id="general"
                                        >
                                          <AvailableSeats
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            errors={errors}
                                            control={control}
                                            reset={reset}
                                            availableSeats={availableSeats}
                                            invoice={invoice}
                                            bgroupName={bgroupName}
                                            billinggroupid={
                                              billingGInfo.billing_group_id
                                            }
                                            setSuccessMessage={
                                              setSuccessMessage
                                            }
                                            //    setAvailableSeats={setAvailableSeats}
                                          />
                                        </div>
                                      </section>
                                    </>
                                  )}
                                {!isWholesaleAcc && (
                                  <>
                                    <div class="routing-border mt-2"></div>
                                    <section ref={section8} id="section-8">
                                      <div
                                        className="general-settings"
                                        id="general"
                                      >
                                        <BillingGroupAdmin
                                          register={register}
                                          watch={watch}
                                          setValue={setValue}
                                          errors={errors}
                                        />
                                      </div>
                                    </section>
                                    {billingGInfo.billing_group_type ===
                                      "Invoice" && (
                                      <>
                                        <div class="routing-border mt-2"></div>

                                        <section ref={section9} id="section-9">
                                          <BillingAvailablePHNumbers
                                            billingID={
                                              billingGInfo?.billing_group_id ??
                                              ""
                                            }
                                            errors={errors}
                                            setError={setError}
                                            // sourceNumber={sourceNumber}
                                            setSuccessMessage={
                                              setSuccessMessage
                                            }
                                            setIsloading={setIsloading}
                                          />
                                        </section>
                                      </>
                                    )}

                                    <div class="routing-border mt-2"></div>
                                    <section
                                      ref={section10}
                                      id="section-10"
                                      style={{ marginBottom: "25 rem" }}
                                    >
                                      <HardwareProducts
                                        register={register}
                                        setValue={setValue}
                                        getValues={getValues}
                                        watch={watch}
                                        control={control}
                                        errors={errors}
                                        reset={reset}
                                        hwProductList={hwProductList}
                                        hwRentalList={hwRentalList}
                                        emiProductList={emiProductList}
                                        hwEditable={hwEditable}
                                        invoice={invoice}
                                      />
                                    </section>
                                    {billingGInfo.billing_group_type ===
                                      "Sub total" && (
                                      <>
                                        <div class="routing-border mt-2"></div>
                                        <section
                                          ref={section11}
                                          id="section-11"
                                        >
                                          <div
                                            className="mainText mt-3"
                                            id="general"
                                          >
                                            Default Invoice
                                          </div>

                                          {/* <BillingInvoice /> */}
                                          <div className="add-numbermain">
                                            <div class="tel-numbers">
                                              Billing Groups
                                            </div>

                                            <div className="w-30 pb-5">
                                              <select
                                                name=""
                                                id=""
                                                className="form-select"
                                                value={watch("default_invoice")}
                                                onChange={(e) =>
                                                  setValue(
                                                    "default_invoice",
                                                    parseInt(e.target.value),
                                                    { shouldDirty: true }
                                                  )
                                                }
                                              >
                                                {invoice.length > 0 &&
                                                  invoice.map((info) => (
                                                    <option
                                                      value={
                                                        info.billing_group_id
                                                      }
                                                    >
                                                      {info.group_name}
                                                    </option>
                                                  ))}
                                              </select>
                                            </div>
                                          </div>
                                        </section>
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                              {isSave && (
                                <SaveChanges
                                  onClose={closeSave}
                                  isdirtyFields={isSave}
                                  onSave={(e) => {
                                    e.preventDefault();
                                    handleSubmit(onSubmit)();
                                  }}
                                />
                              )}
                            </div>
                          </MDBCol>
                        </MDBRow>
                      </MDBTabsPane>
                      {!isWholesaleAcc && (
                        <MDBTabsPane open={basicActive === "tab2"}>
                          <BillingUsers
                            billingGInfo={billingGInfo}
                            isActive={basicActive === "tab2"}
                          />
                        </MDBTabsPane>
                      )}
                      {/* {userToRemove && (
                                                <PopupLoaderNew
                                                    title={"Remove User"}
                                                    content={
                                                        <DeleteUsers
                                                            deletUser={deletuser}
                                                            onClose={dtogglePopup}
                                                            ref={removeUserRef}
                                                            billingGInfo={billingGInfo}
                                                            setIsloading={setisLoading}
                                                        />}
                                                    onShow={setUserToRemove}
                                                    onSave={handleClick}
                                                    onClose={dtogglePopup}
                                                    isloading={isLoading}
                                                    flag={4}

                                                />
                                            )} */}
                      {!isWholesaleAcc && (
                        <MDBTabsPane open={basicActive === "tab3"}>
                          <BillingGroups
                            billingGInfo={billingGInfo}
                            isActive={basicActive === "tab3"}
                          />
                        </MDBTabsPane>
                      )}
                      {/* <MDBTabsPane open={basicActive === "tab4"}>
                        <div>
                          <div className="actionbar"></div>
                          <div className="locationUsersDatatble">
                            <MDBDatatable
                              search
                              data={actionData}
                              className="actioncolumn"
                              sortField="Billing Groups"
                            />
                          </div>
                        </div>
                      </MDBTabsPane> */}
                      {!isWholesaleAcc && (
                        <MDBTabsPane open={basicActive === "tab5"}>
                          <BillingInvoice
                            groupid={billingGInfo.billing_group_id}
                            isActive={basicActive === "tab5"}
                          />
                        </MDBTabsPane>
                      )}
                    </MDBTabsContent>
                    {isloading && (
                      <>
                        <div className="loadingclass">
                          <MDBBtn disabled>
                            <MDBSpinner
                              size="sm"
                              role="status"
                              tag="span"
                              className="me-2"
                            />
                            Loading...
                          </MDBBtn>
                        </div>
                      </>
                    )}

                    {successMessage && (
                      <MDBAlert
                        open
                        className="alert-center"
                        color="success"
                        autohide
                        position="bottom-right"
                        delay={10000}
                      >
                        <i className="fas fa-check-circle me-3"></i>
                        <span className="alert-msg">{successMessage}</span>
                      </MDBAlert>
                    )}
                  </div>
                </div>
              </section>

              {showWarning && (
                <EditWarning
                  warningToggle={warningToggle}
                  setShowWarning={setShowWarning}
                  onOk={handleOk}
                />
              )}

              <Tooltip
                anchorSelect=".deleteToolTip"
                place="top"
                className="exampleTooltip"
              >
                Remove
              </Tooltip>
              <Tooltip
                anchorSelect=".AvailableSeats"
                place="right"
                className="exampleTooltipLight w-25"
              >
                Available Seats section display a summary of Seats available
                with an option to assign Un-used seats to other invoice billing
                groups.
              </Tooltip>
              <Tooltip
                anchorSelect=".AvailablePhoneNumbers"
                place="right"
                className="exampleTooltipLight w-25"
              >
                Available Phone Numbers section display the phone numbers
                available for this billing group. The available phone number(s)
                can be assigned to another invoice billing group.
              </Tooltip>
              <Tooltip
                anchorSelect=".HardwareProducts"
                place="right"
                className="exampleTooltipLight w-25"
              >
                Hardware, Hardware Rental & Finance section displays the
                quantity of hardware, hardware rental and NRC Finance price of
                this billing group. The available hardware quantity and NRC
                price can be assigned to another invoice billing group.
              </Tooltip>
              <Tooltip
                anchorSelect=".InvoiceTooltip"
                place="top"
                className="exampleTooltipLight w-25"
              >
                Invoice section displays the previous month(s) invoice with an
                option to view and download.
              </Tooltip>
            </>
          }
        />
      </>
    </React.Fragment>
  );
}

export default BillingGroupDetails;
